<template>
    <b-container fluid class="max-width">
        <title-back-button 
            :title="trans('community.profile-edit.profile')"
        />
        <div class="row justify-content-center" v-if="!isLoading">
            <div class="col-md-10 pb-5">
                <b-row>
                    <profile-sidebar :links="profileLinks" />
                    <router-view :isActivation="false" name="profile" :currentUserId="currentUserId" />

                    <div class="col-md-8 justify-content-center" v-if="this.$route.fullPath !== '/profile'">
                        <router-view :isActivation="false" />
                    </div>
                </b-row>
            </div>
        </div>
        <div v-else class="w-100 d-flex justify-content-center">
            <b-spinner class="align-middle" variant="secondary" />
        </div>
    </b-container>
</template>

<script>
    import ProfileSidebar from "../../organisms/ProfileSidebar";
    import TitleBackButton from "../../molecules/TitleBackButton";

    import { mapGetters, mapActions } from "vuex";

    export default {
        name: "ProfileContainer",
        components: {ProfileSidebar, TitleBackButton},
        data() {
            return {
                isLoading: true
            }
        },
        methods:{
             ...mapActions({
                setUserProfileInfo: 'user/userProfileInfo'
            }),
        },
        mounted(){
            trackEvent("ProfileDashboardView", {})
            this.setUserProfileInfo(this.currentUserId)
        },
        computed: {
            ...mapGetters({
                getCurrentUserId: 'user/getUserId',
                userProfileInfo: 'user/getUserProfileInfo'
            }),
            currentUserId: function () {
                return this.getCurrentUserId
            },
            isRootComponent: function () {
                return !Object.keys(this.$route.params).length
            },
            profileLinks: function() {
                return this.userProfileInfo.links.filter(item => !item.route.includes("account"))
            }
        },
        watch: {
            userProfileInfo() {
                this.isLoading = false
            }
        }
    }
</script>
